// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--headBackColor:#001852;--sideBackColor:#123072}.animated{animation-duration:1.5s;animation-fill-mode:both;animation-iteration-count:20}.tree-boxs ::v-deep .el-tree-node__label{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
